import CertificationsTab from './CertificationsTab';
export default CertificationsTab;